import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enCommon from "./locales/en/common.json";
import enContactEdit from "./locales/en/contactEdit.json";
import enRespond from "./locales/en/respond.json";
import jaCommon from "./locales/ja/common.json";
import jaContactEdit from "./locales/ja/contactEdit.json";
import jaRespond from "./locales/ja/respond.json";
import ptCommon from "./locales/pt/common.json";
import ptContactEdit from "./locales/pt/contactEdit.json";
import ptRespond from "./locales/pt/respond.json";
import viCommon from "./locales/vi/common.json";
import viContactEdit from "./locales/vi/contactEdit.json";
import viRespond from "./locales/vi/respond.json";
import zhCommon from "./locales/zh/common.json";
import zhContactEdit from "./locales/zh/contactEdit.json";
import zhRespond from "./locales/zh/respond.json";

// 対応言語。URL の :lang セグメントと突き合わせる
export const SUPPORTED_LOCALES = ["ja", "en", "zh", "vi", "pt"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = "ja";
export const FALLBACK_LOCALE: SupportedLocale = "ja";

export function isSupportedLocale(value: string | undefined): value is SupportedLocale {
  return !!value && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

const resources = {
  ja: { common: jaCommon, respond: jaRespond, contactEdit: jaContactEdit },
  en: { common: enCommon, respond: enRespond, contactEdit: enContactEdit },
  zh: { common: zhCommon, respond: zhRespond, contactEdit: zhContactEdit },
  vi: { common: viCommon, respond: viRespond, contactEdit: viContactEdit },
  pt: { common: ptCommon, respond: ptRespond, contactEdit: ptContactEdit },
} as const;

// URL の :lang セグメントが言語決定の一次ソースなので、
// LanguageDetector は localStorage / navigator のみフォールバックとして利用
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: FALLBACK_LOCALE,
    supportedLngs: SUPPORTED_LOCALES,
    defaultNS: "common",
    ns: ["common", "respond", "contactEdit"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "wellcheck.customer.lang",
      caches: ["localStorage"],
    },
    returnNull: false,
  });

export default i18n;
